<template>
  <div class="community-mini-container">
    <el-row :gutter="16">
      <!-- 左侧小区选择 -->
      <el-col :xs="24" :sm="24" :md="6" :lg="5">
        <div class="ds-side-card">
          <div class="ds-side-card__header">{{ $t('communityMini.communityList') }}</div>
          <div class="ds-side-card__body">
            <select-admin-community :community-id="communityId" @changeCommunity="handleCommunityChange" />
          </div>
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="18" :lg="19">
        <!-- (1) PageHeader -->
        <ds-page-header :title="$t('communityMini.page.title')" :subtitle="$t('communityMini.page.subtitle')">
          <template #extra>
            <el-button v-if="smallWeChats.length === 0 && conditions.communityId" type="primary" icon="el-icon-plus"
              @click="openAddModal">
              {{ $t('communityMini.add') }}
            </el-button>
          </template>
        </ds-page-header>

        <!-- (3)(4)(6) Toolbar + DataTable + PaginationBar -->
        <div class="ds-panel">
          <ds-toolbar :total="smallWeChats.length" :density="density" :show-column-setting="false" :show-refresh="true"
            @update:density="density = $event" @refresh="loadSmallWeChats">
            <template #left>
              <span class="ds-panel__title">{{ $t('communityMini.title') }}</span>
            </template>
          </ds-toolbar>

          <ds-data-table :data="smallWeChats" :loading="loading" :error="hasError" :error-message="errorMessage"
            :density="density" border :empty-description="$t('communityMini.page.empty')" @retry="loadSmallWeChats">
            <el-table-column prop="name" :label="$t('communityMini.name')" align="center" min-width="140" />
            <el-table-column prop="communityName" :label="$t('communityMini.communityName')" align="center" min-width="140" />
            <el-table-column prop="appId" label="APPID" align="center" min-width="180">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.appId || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('communityMini.appSecret')" align="center" width="140">
              <template>
                <span class="ds-num">********</span>
              </template>
            </el-table-column>
            <el-table-column prop="remarks" :label="$t('communityMini.description')" align="center" min-width="140"
              show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.remarks || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('communityMini.operation')" align="center" width="100" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="openEditModal(scope.row)">
                  {{ $t('communityMini.edit') }}
                </el-button>
              </template>
            </el-table-column>
          </ds-data-table>

          <ds-pagination-bar :total="smallWeChats.length" :page="1" :size="smallWeChats.length || 10"
            :page-sizes="[10, 20, 30, 50]">
            <template #summary>
              <span class="ds-tip-text">{{ $t('communityMini.page.tip') }}</span>
            </template>
          </ds-pagination-bar>
        </div>
      </el-col>
    </el-row>

    <add-community-wechat ref="addModal" @success="loadSmallWeChats" />
    <edit-community-wechat ref="editModal" @success="loadSmallWeChats" />
  </div>
</template>

<script>
import { listAdminSmallWeChats } from '@/api/community/communityMiniApi'
import SelectAdminCommunity from '@/components/community/selectAdminCommunity'
import AddCommunityWechat from '@/components/community/addCommunityWechat'
import EditCommunityWechat from '@/components/community/editCommunityWechat'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'

export default {
  name: 'CommunityMiniList',
  components: {
    SelectAdminCommunity,
    AddCommunityWechat,
    EditCommunityWechat,
    DsPageHeader,
    DsToolbar,
    DsDataTable,
    DsPaginationBar
  },
  data() {
    return {
      conditions: {
        communityId: '',
        weChatType: '1000',
        page: 1,
        row: 100
      },
      smallWeChats: [],
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default'
    }
  },
  computed: {
    /**
     * 当前小区 ID（供左侧选择器回显）
     */
    communityId() {
      return this.conditions.communityId
    }
  },
  mounted() {
    this.loadSmallWeChats()
  },
  methods: {
    async loadSmallWeChats() {
      this.loading = true
      this.hasError = false
      this.errorMessage = ''
      try {
        const res = await listAdminSmallWeChats(this.conditions)
        if (res.code === 0) {
          this.smallWeChats = Array.isArray(res.data) ? res.data : []
        } else {
          this.hasError = true
          this.errorMessage = res.msg || this.$t('communityMini.page.loadFailed')
          this.$message.error(res.msg || this.$t('communityMini.page.loadFailed'))
        }
      } catch (error) {
        console.error('加载小程序列表失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('communityMini.page.loadFailed')
      } finally {
        this.loading = false
      }
    },
    handleCommunityChange(community) {
      this.conditions.communityId = community.communityId
      this.loadSmallWeChats()
    },
    openAddModal() {
      const params = {
        objId: this.conditions.communityId,
        communityId: this.conditions.communityId,
        weChatType: '1000'
      }
      this.$refs.addModal.open(params)
    },
    openEditModal(row) {
      this.$refs.editModal.open(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.community-mini-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 左侧小区选择卡片 */
.ds-side-card {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &__header {
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    font-size: var(--ds-font-size-sm);
    font-weight: 600;
    color: var(--ds-gray-700);
    background: var(--ds-gray-100);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__body {
    padding: var(--ds-spacing-md);
  }
}

/* 表格 + 分页 组成的白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

/* 分页条左侧提示文案 */
.ds-tip-text {
  font-size: var(--ds-font-size-xs);
  color: var(--ds-gray-500);
  line-height: 1.6;
}
</style>
